import React, { useEffect, useState } from 'react';
import '../styles/components/InteractionSummary.css';
import { api, fetchData } from '../services/api';
import { PATH_SEGMENTS } from '../config/paths';
import JsonTable from './JsonTable';

interface InteractionSummaryProps {
  interactionId: string | number;
  transcriptId: string | number;
}

const InteractionSummary: React.FC<InteractionSummaryProps> = ({ interactionId, transcriptId }) => {
  const [summary, setSummary] = useState<Record<string, string> | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSummary = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchData<Record<string, string>>(
          api(PATH_SEGMENTS.SUMMARY, transcriptId)
        );
        if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
          throw new Error('No summary data available');
        }
        setSummary(data);
      } catch (err: any) {
        setError(err.message || 'Failed to fetch summary data');
      } finally {
        setLoading(false);
      }
    };
    fetchSummary();
  }, [transcriptId]);

  if (loading) return <div className="interaction-summary loading">Loading summary...</div>;
  if (error) return <div className="interaction-summary error">{error}</div>;
  if (!summary) return null;

  return (
    <div className="interaction-summary">
      {Object.entries(summary).map(([field, value]) => (
        <div className="summary-field" key={field}>
          <div className="summary-field-name">{field}</div>
          <div className="summary-field-value"><JsonTable value={value} /></div>
        </div>
      ))}
    </div>
  );
};

export default InteractionSummary; 